import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./wordpressSlugContent.html";
import Icon from '@oneappexchange/appx-design-system/modules/ax/icon/icon';
import { WireStore } from '@oneappexchange/lwc-wired';
import { WORDPRESS_SERVICE_URL } from '~/modules/config';
import { htmlDecode, loadWordPressScript } from '~/modules/helpers/wordPressHelper';
import { routerStore, selectPreviewIdQueryParam } from '~/modules/stores/routerStore';
import { selectSlugContent, wordPressStore } from '~/modules/stores/wordpress_store';
import '../../../mfes/cmsElements';
import '../../../mfes/cmsElementsDynamic';

// @ts-expect-error * Automated Type Error Fix
Icon.defaultSpriteUrl = undefined;
class Content extends LightningElement {
  constructor(...args) {
    super(...args);
    this.slug = void 0;
    this.section = void 0;
  }
  wordPressContentUpdated(state) {
    const contentData = selectSlugContent(state, this.slug);
    if (contentData && !contentData.isError && !contentData.isLoading && contentData.data) {
      const container = this.template.querySelector('div');
      if (container) {
        const stylesheet = document.createElement('link');
        stylesheet.setAttribute('rel', 'stylesheet');
        stylesheet.setAttribute('href', `${WORDPRESS_SERVICE_URL}/wp-content/themes/appexchange/dist/css/frontend.css`);

        // eslint-disable-next-line @lwc/lwc/no-inner-html
        container.innerHTML = htmlDecode(contentData.data.content.rendered);
        container.appendChild(stylesheet);
      }
    }
    if (contentData) {
      this.contentData = contentData;
    }
  }
  connectedCallback() {
    loadWordPressScript();
    const routerStoreState = routerStore.getState();
    const previewToken = selectPreviewIdQueryParam(routerStoreState);
    wordPressStore.setPreviewId(previewToken);
    wordPressStore.fetchSlugContent(this.slug, this.section);
  }
  get showContent() {
    return this.contentData && !this.contentData.isLoading && !this.contentData.isError;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Content, {
  publicProps: {
    slug: {
      config: 0
    },
    section: {
      config: 0
    }
  },
  wire: {
    wordPressContentUpdated: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: wordPressStore
        };
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(Content, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;